export default __webpack_public_path__ + "static/Starling-600973cc2f8169184f5c146e68105ec3.png";